import { readSession, writeSession } from '@/shared/lib/sessionStorage';
import type { ExitIntentSignal } from '../../config/exitIntent';
import { EXIT_INTENT_SHOWN_KEY, EXIT_INTENT_WARMED_KEY } from '../../config/exitIntent';

export function hasExitIntentBeenShown(): boolean {
  return Boolean(readSession<boolean>(EXIT_INTENT_SHOWN_KEY));
}

export function claimExitIntentShow(): boolean {
  if (hasExitIntentBeenShown()) return false;
  writeSession(EXIT_INTENT_SHOWN_KEY, true);
  return true;
}

export function hasWarmedUp(): boolean {
  return Boolean(readSession<boolean>(EXIT_INTENT_WARMED_KEY));
}

export function markWarmedUp(): void {
  writeSession(EXIT_INTENT_WARMED_KEY, true);
}

export type ExitIntentTrigger = (signal: ExitIntentSignal) => void;

export function createExitIntentTrigger({
  spentRef,
  onFire,
}: {
  spentRef: { current: boolean };
  onFire: (signal: ExitIntentSignal) => void;
}): ExitIntentTrigger {
  return signal => {
    if (spentRef.current) return;
    spentRef.current = true;
    if (!claimExitIntentShow()) return;
    onFire(signal);
  };
}
